import { Component, EventEmitter, Input, Output } from '@angular/core';
export interface FilterOption<T> {
  title: string;
  value: T;
}

export interface DropdownFilter<T> {
  name: string;
  options: FilterOption<T>[];
}

@Component({
  selector: 'app-filter-drop-down',
  templateUrl: './filter-drop-down.component.html',
  styleUrls: ['./filter-drop-down.component.scss'],
})
export class FilterDropDownComponent<T> {
  @Input({ required: false }) public isLoading = false;
  @Input({ required: false }) public hideElement = false;
  @Input({ required: true }) public filter: DropdownFilter<T>;
  @Input({ required: true }) public selectedFilter: FilterOption<T>;

  @Output() public filterSelected: EventEmitter<FilterOption<T>> = new EventEmitter<FilterOption<T>>();

  public onFilterSelect(item: FilterOption<T>): void {
    this.filterSelected.emit(item);
  }
}
